var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-md-4"},_vm._l((_vm.configs),function(config,index){return _c('StepItem',_vm._b({key:index,attrs:{"active":true,"isLast":index == _vm.configs.length - 1}},'StepItem',config,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }